import { FinanceType, LoadingStatusType, PaymentInOutFlowType } from "@/enums/enums";
import { ToAccountMonitoringList } from "@/service/account/accountFacade";
import { ToFinanceMonitoringList, ToUnreceivedCheque } from "@/service/finance/financeFacade";
import API from "@/service/Index";
import {
  ToRevenueExpense,
  ToSummaryAccount,
  ToSummaryFinance,
  ToSummaryInvoiceRemainPayment,
  ToSummaryProduct,
} from "@/service/summary/summaryFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class DashBoard extends VuexModule {
  public revenueExpenseSummary: any = [];
  public revenueExpenseSummaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public invoiceSummaryRemainPayment: any = [];
  public invoiceSummaryRemainPaymentLoadingStaut: LoadingStatusType = LoadingStatusType.None;
  public financeSummary: any = [];
  public financeSummaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public unreceivedChequeCashIn: any = {};
  public unreceivedChequeCashInLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public unreceivedChequeCashOut: any = {};
  public unreceivedChequeCashOutLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public financeMonitoringList: any = [];
  public merchantMonitoringFinanceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public setMerchantMonitoringFinanceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public accountMonitoringList: any = [];
  public merchantMonitoringAccountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public setMerchantMonitoringAccountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public revenueProductSummary: any = [];
  public revenueProductSummaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public expenseAccountSummary: any = {};
  public expenseAccountSummaryLoadingStatus: any = LoadingStatusType.None;

  get getRevenueExpenseList(): any {
    return this.revenueExpenseSummary;
  }
  get getRevenueExpenseLoadingStatus(): LoadingStatusType {
    return this.revenueExpenseSummaryLoadingStatus;
  }
  get getInvoiceSummaryRemainPayment(): any {
    return this.invoiceSummaryRemainPayment;
  }
  get getInvoiceSummaryRemainPaymentLoadingStatus(): LoadingStatusType {
    return this.invoiceSummaryRemainPaymentLoadingStaut;
  }
  get getFinanceSummary(): any {
    return this.financeSummary;
  }
  get getFinanceSummaryLoadingStatus(): LoadingStatusType {
    return this.financeSummaryLoadingStatus;
  }
  get getUnreceivedChequeCashIn(): any {
    return this.unreceivedChequeCashIn;
  }
  get getUnreceivedChequeCashInLoadingStatus(): LoadingStatusType {
    return this.unreceivedChequeCashInLoadingStatus;
  }
  get getUnreceivedChequeCashOut(): any {
    return this.unreceivedChequeCashOut;
  }
  get getUnreceivedChequeCashOutLoadingStatus(): LoadingStatusType {
    return this.unreceivedChequeCashOutLoadingStatus;
  }
  get getFinanceMonitoringList(): any {
    return this.financeMonitoringList;
  }
  get getMerchantMonitoringFinanceLoadingStatus(): LoadingStatusType {
    return this.merchantMonitoringFinanceLoadingStatus;
  }
  get getSetMerchantMonitoringFinanceLoadingStatus(): LoadingStatusType {
    return this.setMerchantMonitoringFinanceLoadingStatus;
  }
  get getAccountMonitoringList(): any {
    return this.accountMonitoringList;
  }
  get getMerchantMonitoringAccountLoadingStatus(): LoadingStatusType {
    return this.merchantMonitoringAccountLoadingStatus;
  }
  get getSetMerchantMonitoringAccountLoadingStatus(): LoadingStatusType {
    return this.setMerchantMonitoringAccountLoadingStatus;
  }
  get getSummaryIncome(): any {
    return this.revenueProductSummary;
  }
  get getSummaryIncomeLoadingStatus(): LoadingStatusType {
    return this.revenueProductSummaryLoadingStatus;
  }

  get getExpenseAccountSummary(): any {
    return this.expenseAccountSummary;
  }
  get getExpenseAccountSummaryLoadingStatus(): LoadingStatusType {
    return this.expenseAccountSummaryLoadingStatus;
  }

  @Mutation
  public MutaionSetRevenueExpenseSummaryLoadingStatus(status: LoadingStatusType) {
    this.revenueExpenseSummaryLoadingStatus = status;
  }

  @Mutation
  public MutationSetInvoiceSummaryRemainPaymentLoadingStaut(status: LoadingStatusType) {
    this.invoiceSummaryRemainPaymentLoadingStaut = status;
  }

  @Mutation
  public MutationSetFinanceSummaryLoadingStatus(status: LoadingStatusType) {
    this.financeSummaryLoadingStatus = status;
  }

  @Mutation
  public MutationSetUnreceivedChequeCashInLoadingStatus(status: LoadingStatusType) {
    this.unreceivedChequeCashInLoadingStatus = status;
  }

  @Mutation
  public MutationSetUnreceivedChequeCashOutLoadingStatus(status: LoadingStatusType) {
    this.unreceivedChequeCashOutLoadingStatus = status;
  }

  @Mutation
  public MutationGetMerchantMonitoringFinanceLoadingStatus(status: LoadingStatusType) {
    this.merchantMonitoringFinanceLoadingStatus = status;
  }

  @Mutation
  public MutationSetMerchantMonitoringFinanceLoadingStatus(status: LoadingStatusType) {
    this.setMerchantMonitoringFinanceLoadingStatus = status;
  }

  @Mutation
  public MutationMerchantMonitoringAccountLoadingStatus(status: LoadingStatusType) {
    this.merchantMonitoringAccountLoadingStatus = status;
  }

  @Mutation
  public MutationSetMerchantMonitoringAccountLoadingStatus(status: LoadingStatusType) {
    this.setMerchantMonitoringAccountLoadingStatus = status;
  }

  @Mutation
  public MutationSetRevenueProductSummaryLoadingStatus(status: LoadingStatusType) {
    this.revenueProductSummaryLoadingStatus = status;
  }

  @Mutation
  public MutationSetExpenseAccountSummaryLoadingStatus(status: LoadingStatusType) {
    this.expenseAccountSummaryLoadingStatus = status;
  }

  @Mutation
  public MutationRevenueExpenseSummary(_revenueExpenseSummary: any) {
    this.revenueExpenseSummary = _revenueExpenseSummary;
  }

  @Mutation
  public MutationInvoiceSummaryRemainPayment(_invoiceSummaryRemainPayment: any) {
    this.invoiceSummaryRemainPayment = _invoiceSummaryRemainPayment;
  }

  @Mutation
  public MutationFinanceSummary(_expenseAccounttSummary: any) {
    this.financeSummary = _expenseAccounttSummary;
  }

  @Mutation
  public MutationUnreceivedCheque(_unreceivedCheque: any) {
    switch (_unreceivedCheque.type) {
      case PaymentInOutFlowType.CashIn:
        this.unreceivedChequeCashIn = _unreceivedCheque.unreceivedCheque;
        break;

      case PaymentInOutFlowType.CashOut:
        this.unreceivedChequeCashOut = _unreceivedCheque.unreceivedCheque;
        break;
    }
  }

  @Mutation
  public MutationFinanceMonitoringList(_financeMonitoringList: any) {
    this.financeMonitoringList = _financeMonitoringList;
  }

  @Mutation
  public MutationAccountMonitoringList(_accountMonitoringList: any) {
    this.accountMonitoringList = _accountMonitoringList;
  }

  @Mutation
  public MutationSummaryIncome(_summaryIncome: any) {
    this.revenueProductSummary = _summaryIncome;
  }

  @Mutation
  public MutationExpenseAccountSummary(_expenseAccounttSummary: any) {
    this.expenseAccountSummary = _expenseAccounttSummary;
  }

  @Action
  public DoGetRevenueExpenseSummary(year: number) {
    if (this.revenueExpenseSummaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutaionSetRevenueExpenseSummaryLoadingStatus", LoadingStatusType.Loading);
      API.SummaryService.DoGetRevenueExpenseSummary(year)
        .then((res) => {
          const revenueExpenseSummary = ToRevenueExpense(res.data.revenueExpenseSummary, year);
          this.context.commit("MutationRevenueExpenseSummary", revenueExpenseSummary);
          this.context.commit("MutaionSetRevenueExpenseSummaryLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoSummaryInvoiceRemainPayment(_financeTypeId: FinanceType) {
    if (this.invoiceSummaryRemainPaymentLoadingStaut !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetInvoiceSummaryRemainPaymentLoadingStaut", LoadingStatusType.Loading);
      API.SummaryService.DoSummaryInvoiceRemainPayment(_financeTypeId)
        .then((res) => {
          const invoiceSummaryRemainPayment = ToSummaryInvoiceRemainPayment(res.data.invoiceSummaryRemainPayment);
          this.context.commit("MutationInvoiceSummaryRemainPayment", invoiceSummaryRemainPayment);
          this.context.commit("MutationSetInvoiceSummaryRemainPaymentLoadingStaut", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetFinanceSummary(typeOption: number) {
    if (this.financeSummaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetFinanceSummaryLoadingStatus", LoadingStatusType.Loading);
      API.SummaryService.DoGetFinanceSummary(typeOption)
        .then((res) => {
          const financeSummary = ToSummaryFinance(res.data.accountMonitoringList);
          this.context.commit("MutationFinanceSummary", financeSummary);
          this.context.commit("MutationSetFinanceSummaryLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetUnreceivedCheque(type: PaymentInOutFlowType) {
    switch (type) {
      case PaymentInOutFlowType.CashIn:
        this.context.commit("MutationSetUnreceivedChequeCashInLoadingStatus", LoadingStatusType.Loading);
        break;
      case PaymentInOutFlowType.CashOut:
        this.context.commit("MutationSetUnreceivedChequeCashOutLoadingStatus", LoadingStatusType.Loading);
        break;
    }

    API.FinanceService.DoGetUnreceivedCheque(type)
      .then((res) => {
        const unreceivedCheque = ToUnreceivedCheque(res.data.unreceivedCheque);
        this.context.commit("MutationUnreceivedCheque", {
          unreceivedCheque: unreceivedCheque,
          type: type,
        });
        switch (type) {
          case PaymentInOutFlowType.CashIn:
            this.context.commit("MutationSetUnreceivedChequeCashInLoadingStatus", LoadingStatusType.Success);
            break;
          case PaymentInOutFlowType.CashOut:
            this.context.commit("MutationSetUnreceivedChequeCashOutLoadingStatus", LoadingStatusType.Success);
            break;
        }
      })
      .catch((error) => error);
  }

  @Action
  public DoGetMerchantMonitoringFinance() {
    if (this.merchantMonitoringFinanceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetMerchantMonitoringFinanceLoadingStatus", LoadingStatusType.Loading);
      API.FinanceService.DoGetMerchantMonitoringFinance()
        .then((res) => {
          const financeMonitoringList = ToFinanceMonitoringList(res.data.financeMonitoringList);
          this.context.commit("MutationFinanceMonitoringList", financeMonitoringList);
          this.context.commit("MutationGetMerchantMonitoringFinanceLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoSetMerchantMonitoringFinance(_followingList: any) {
    if (this.setMerchantMonitoringFinanceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetMerchantMonitoringFinanceLoadingStatus", LoadingStatusType.Loading);
      API.FinanceService.DoSetMerchantMonitoringFinance(_followingList)
        .then(() => {
          API.FinanceService.DoGetMerchantMonitoringFinanceByFinanceIdList(_followingList).then((res) => {
            const financeMonitoringList = ToFinanceMonitoringList(res.data.financeMonitoringList);
            this.context.commit("MutationFinanceMonitoringList", financeMonitoringList);
            this.context.commit("MutationSetMerchantMonitoringFinanceLoadingStatus", LoadingStatusType.Success);
          });
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetMerchantMonitoringAccount() {
    if (this.merchantMonitoringAccountLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationMerchantMonitoringAccountLoadingStatus", LoadingStatusType.Loading);
      API.AccountService.DoGetMerchantMonitoringAccount()
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const accountMonitoringList = ToAccountMonitoringList(res.data.accountMonitoringList);
            this.context.commit("MutationAccountMonitoringList", accountMonitoringList);
          }
          this.context.commit("MutationMerchantMonitoringAccountLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoSetMerchantMonitoringAccount(_followingList: any) {
    if (this.setMerchantMonitoringAccountLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationMerchantMonitoringAccountLoadingStatus", LoadingStatusType.Loading);
      API.AccountService.DoSetMerchantMonitoringAccount(_followingList)
        .then(() => {
          API.AccountService.DoGetMerchantMonitoringAccountByAccountIdList(_followingList).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const accountMonitoringList = ToAccountMonitoringList(res.data.accountMonitoringList);
              this.context.commit("MutationAccountMonitoringList", accountMonitoringList);
            }
            this.context.commit("MutationMerchantMonitoringAccountLoadingStatus", LoadingStatusType.Success);
          });
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetRevenueProductSummary(typeOption: number) {
    if (this.revenueProductSummaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetRevenueProductSummaryLoadingStatus", LoadingStatusType.Loading);
      API.SummaryService.DoGetRevenueProductSummary(typeOption)
        .then((res) => {
          const summaryIncome = ToSummaryProduct(res.data.trialBalanceDataList);
          this.context.commit("MutationSummaryIncome", summaryIncome);
          this.context.commit("MutationSetRevenueProductSummaryLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }

  @Action
  public DoGetExpenseAccountSummary(typeOption: any) {
    if (this.expenseAccountSummaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetExpenseAccountSummaryLoadingStatus", LoadingStatusType.Loading);
      API.SummaryService.DoGetExpenseAccountSummary(typeOption)
        .then((res) => {
          const expenseAccountSummary = ToSummaryAccount(res.data.expenseAccountSummary);
          this.context.commit("MutationExpenseAccountSummary", expenseAccountSummary);
          this.context.commit("MutationSetExpenseAccountSummaryLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
}
